// src/utils/wallet-totals.ts
import { WalletInterface } from "../models/Wallet";

export type WalletsByCurrency = Record<string, WalletInterface[]>;

export const groupWalletsByCurrency = (wallets: WalletInterface[]): WalletsByCurrency => {
    const groups: WalletsByCurrency = {};

    wallets.forEach((wallet) => {
        const symbol = wallet.asset.symbol.toUpperCase();
        if (!groups[symbol]) groups[symbol] = [];
        groups[symbol].push(wallet);
    });

    return groups;
};

export const sumWalletsBalance = (wallets: WalletInterface[]): number =>
    wallets.reduce((total, wallet) => total + Number(wallet.balance), 0);